import { render, staticRenderFns } from "./TodoTypesManager.vue?vue&type=template&id=0e7c028d&"
import script from "./TodoTypesManager.vue?vue&type=script&lang=ts&"
export * from "./TodoTypesManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports